import React, { ReactNode } from 'react'
import { TextField,Box } from '@mui/material';
import CustomFormLabel from '../form-label/CustomFormLabel ';
interface TextBoxLatestType {
    id?: number | string;
    multiline?: boolean;
    placeholder?: string;
    isMandotary? : boolean;
    onchangeHandler?: (e:any) => void;
    onKeyDownHandler?: (e:any) => void;
    onBlur?: (e:any) => void;
    onInput?: (e:any) => void;
    title?: string;
    ref:any;
    type?:string;
    name?:string;
    errorMsg?:string|ReactNode;
    isError?:boolean;
    disabled?:boolean;
    parentClassNames?:string;
    InputProps?:any;
    required?:boolean;
}
export const TextBoxLatest = React.forwardRef((props:TextBoxLatestType, ref:any=null) => { //(props:TextBoxLatestType) => {
    const {parentClassNames="",onBlur,onInput, multiline=false,name="",InputProps,placeholder="",onchangeHandler,title="",isMandotary=false,type='text',errorMsg="Please Enter",isError=false,disabled=false,onKeyDownHandler,required=false} = props;
  return (
    <Box className={`${parentClassNames} common-new-input-holder`} >
        <CustomFormLabel
            labelName={title}
            isMandotary={isMandotary}
            classNames='app-field-label'
        />
        <TextField
          //id="standard-multiline-flexible"
          fullWidth
          label=""
          type={type}
          inputRef={ref}
          error={(isError && !ref?.current?.value) ? true : false}
          required={required ? required : false}
          multiline={multiline}
          minRows={3}
          // rows={3}
          name={name}
          autoComplete='off'
          disabled={disabled}
          placeholder={placeholder}
          className={`common-new-input ${(isError && !ref?.current?.value) ? "err-field" :""} ${multiline?"multiline":""}`}
          onKeyDown={onKeyDownHandler}
          onChange={onchangeHandler}
          onBlur={onBlur}
          onInput={onInput}
          InputProps={InputProps||null}
          size='small'
        />
        {(isError && !ref?.current?.value) &&
          <CustomFormLabel
              labelName={errorMsg}
              isMandotary={false}
              classNames='txt-danger'
          />
        }
    </Box>
  )
})
